import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from '../icons';
import { Button } from '../ui/button';

export function NLPHero() {
  const navigate = useNavigate();

  return (
    <section className="pt-32 pb-20 md:pt-40 md:pb-28 px-4 md:px-8 bg-nlp-bg relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-nlp-olive/5 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-nlp-gold/5 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4" />

      <div className="max-w-[1216px] mx-auto relative">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-nlp-cream rounded-full mb-6">
              <Sparkles className="w-4 h-4 text-nlp-gold-dark" />
              <span className="text-sm font-semibold text-nlp-forest">
                Your Operating System for Change
              </span>
            </div>

            <h1
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-nlp-forest mb-6 leading-tight"
              style={{ fontFamily: 'Georgia, serif' }}
            >
              Understand Your True Potential.{' '}
              <span className="text-nlp-olive">Anytime, Anywhere.</span>
            </h1>

            <p className="text-lg md:text-xl text-nlp-taupe mb-8 max-w-xl mx-auto lg:mx-0 leading-relaxed">
              NLP OS is your partner in wholeness, growth, and career success.
              Designed to help you understand, manage, and improve your personal
              potential journey.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                size="lg"
                onClick={() => navigate('/register')}
                className="gap-2 bg-nlp-forest text-white hover:bg-nlp-forest-light rounded-full"
              >
                Start Assessment
                <ArrowRight className="w-5 h-5" />
              </Button>
              <Button
                variant="secondary"
                size="lg"
                onClick={() => navigate('/founding-cohort')}
                className="gap-2 bg-nlp-cream text-nlp-forest border border-nlp-cream-dark hover:bg-nlp-cream-dark rounded-full"
              >
                For Coaches & Practitioners
              </Button>
            </div>
          </div>

          <div className="flex-1 relative max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-4 bg-nlp-gold/10 rounded-[40px] transform rotate-3" />
            <div className="relative bg-white rounded-[32px] shadow-xl overflow-hidden border border-nlp-cream-dark">
              <div className="p-6 border-b border-nlp-cream-dark bg-nlp-cream/30">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 bg-nlp-forest rounded-full flex items-center justify-center">
                    <span className="text-white text-xl">🎯</span>
                  </div>
                  <div>
                    <p className="text-sm text-nlp-taupe">Assessment</p>
                    <p className="font-semibold text-nlp-forest">
                      How would you describe yourself?
                    </p>
                  </div>
                </div>
                <div className="flex gap-2">
                  <div className="flex-1 h-2 bg-nlp-forest rounded-full" />
                  <div className="flex-1 h-2 bg-nlp-cream-dark rounded-full" />
                  <div className="flex-1 h-2 bg-nlp-cream-dark rounded-full" />
                </div>
              </div>
              <div className="p-6 space-y-3">
                {[
                  'I am confident in my abilities',
                  'I embrace new challenges',
                  'I connect easily with others',
                ].map((text, i) => (
                  <div
                    key={i}
                    className={`flex items-center gap-3 p-4 rounded-xl border transition-all ${
                      i === 0
                        ? 'border-nlp-forest bg-nlp-cream/40'
                        : 'border-nlp-cream-dark hover:border-nlp-taupe'
                    }`}
                  >
                    <div
                      className={`w-5 h-5 rounded-full flex items-center justify-center ${
                        i === 0 ? 'bg-nlp-forest' : 'bg-nlp-cream-dark'
                      }`}
                    >
                      {i === 0 && (
                        <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                      )}
                    </div>
                    <span className="text-nlp-forest/80 text-sm">{text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-lg p-4 hidden md:block border border-nlp-cream-dark">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-nlp-gold/20 rounded-full flex items-center justify-center">
                  <Sparkles className="w-5 h-5 text-nlp-gold-dark" />
                </div>
                <div>
                  <p className="text-xs text-nlp-taupe">Insights</p>
                  <p className="text-sm font-semibold text-nlp-forest">
                    AI Analysis
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
